// components/PopupVendor/VendorAwardsSection.js
import React from 'react';

const VendorAwardsSection = ({
                                 isCurrentUserVendorOwner,
                                 awards = [],
                                 handlerShowEditAwardsPopup
                             }) => {
    if (!isCurrentUserVendorOwner && awards.length === 0) {
        return null;
    }

    return (
        <div className="profile__block">
            <div className="container">
                <div className="profile__header"><h2>Awards and Articles</h2>
                    {isCurrentUserVendorOwner && (
                        <button className="button no-style" onClick={handlerShowEditAwardsPopup}>
                            <img src="/assets/icon--edit-Z9QfuMgm.svg" alt="Edit Awards"/>
                            {(awards.length === 0) ? 'Add Awards' : 'Edit Awards'}
                        </button>
                    )}
                </div>
                <div className="profile__content">
                    <div className="col-2 decor-list">
                        {awards.map((award, index) => (
                            <div key={index} className="vendor vendor-award decor-list__el">
                                <div className="vendor__award">
                                    {award.image && <img src={award.image} alt={award.title}/>}
                                </div>
                                <div className="vendor__header">
                                    <h4 className="vendor__name">{award.title}</h4>
                                    <span className="vendor__attorney">{award.subtitle}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VendorAwardsSection;